import React from 'react';
import {
  Container,Card, Modal,
  Box, CircularProgress,
  Typography, Divider,
  Button, FormControl,
  Paper, InputBase,
  IconButton, Switch
} from '@material-ui/core';
import {
  Share as ShareIcon,
  CardGiftcard as GiftIcon,
  WorkOutline as WorkshopIcon
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import GameTopPanel from '../../component/game/user_interface/gameTopPanel';
import FooterPanel from '../../component/game/user_interface/gameFooterPanel';

import dndBanner from '../../element/2026/dndbanner.png'
import {GET_JAMBUILDER_BY_ID, GET_EVENT_BY_ID} from '../../api/graphql'
import { DUPLICATE_GAME } from '../../api/graphql-mutation';
import { withApollo } from 'react-apollo';
import { getUserId } from '../../utility/function';

import config from '../../config/backend'

const styles = theme => ({
  root: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  headerBannerOnly:{
    width: '100%',
    height: '225px', 
    overflow: 'hidden',
    //borderRadius: '8px', 
    //marginBottom: '12px' 
  },
  headerBanner: {
    background: 'linear-gradient(135deg, #f5e6d3 0%, #f5d0a9 25%, #f5b380 50%, #f59e6c 75%, #f58b5c 100%)',
    padding: '40px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  headerContent: {
    textAlign: 'center',
    maxWidth: '800px'
  },
  featuredText: {
    color: '#6b4423',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '8px',
    letterSpacing: '0.5px'
  },
  mainTitle: {
    color: 'white',
    fontSize: '48px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px'
  },
  giftIcon: {
    fontSize: '48px',
    color: '#8b5a3c'
  },
  contentContainer: {
    padding: '40px 20px'
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px'
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  workshopIcon: {
    fontSize: '24px',
    color: '#666'
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: 600,
    color: '#333'
  },
  shareButton: {
    color: '#666',
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 500,
    border: '1px solid gray',
    padding: '.4em 1em'
  },
  section: {
    marginBottom: '4em'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '12px'
  },
  overviewText: {
    fontSize: '14px',
    color: '#666',
    lineHeight: 1.6
  },
  sessionCard: {
    padding: '20px',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }
  },
  sessionInfo: {
    flex: 1
  },
  sessionName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#5a8a90',
    marginBottom: '6px'
  },
  sessionDescription: {
    fontSize: '13px',
    color: '#999'
  },
  hostButton: {
    width: "120px",
    backgroundColor: '#ff6b6b',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '12px',
    padding: '8px 24px',
    '&:hover': {
      backgroundColor: '#ff5252'
    }
  },
    popUp: {
        width: "24rem",
        background: "#FAF9F9",
        border: '1px solid #d1d1d1',
        fontFamily:"arial",
        padding:"0",
        borderRadius:"5px",
    },

    popUpHeader:{
        margin:"1.8rem",
        fontWeight:"bold",
        fontSize:"1rem",
        color:"#4F4F4F",
    },

    popUpContent:{
        margin:"1.8rem",
    },

    field:{
        display:"block",
        background:"#FAF7EA",
        border:"1px solid #d1d1d1",
        borderRadius:"5px",
        margin:"0.5em 0 1em 0",
        padding:"0.5em 1em"
    },

    selectField:{
        fontSize: "0.875rem", 
        margin:"0.5em 0 1em 0", 
        background:"#FAF7EA", 
        borderRadius:"5px", 
        border:"1px solid #d1d1d1",
        
        padding:"0 0.5em"
    },

    popUpBtn:{
        display:"block",
        background:"#FDAF2A",
        color:"#fff",
        borderRadius:"5px",
        width:"100%",
        padding:"0.5rem 0.5rem",
        marginTop:"0.5rem",
        fontSize: "0.875rem",
        fontWeight:"bold"
    },

    popUpBtnDisabled:{
        display:"block",
        background:"#D1D1D1",
        color:"#fff",
        borderRadius:"5px",
        width:"100%",
        padding:"0.5rem 0.5rem",
        marginTop:"0.5rem",
        fontSize: "0.875rem",
        fontWeight:"bold"
    },
    modal:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class InkspireEventPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        // sessions: [
        //     {
        //     id: 1,
        //     name: 'S1: Class Quiz',
        //     description: 'Decide Class based on ideal playstyle',
        //     link: '6943c5218617322ae4fdb016',
        //     },
        //     {
        //     id: 2,
        //     name: 'S2: Backstory Jam',
        //     description: 'Jam for character background & story',
        //     link: null,
        //     },
        //     {
        //     id: 3,
        //     name: 'S3: Ability Matchup',
        //     description: "Allocate points for character's ability",
        //     link: null,
        //     }
        // ],

        eventId: null,
        eventName: '',
        bannerImage: null,
        eventDescription: '',
        sessions: [],

        jambuilderData: null,
        isDataReady: false,
        showPopup: false,

        name: "",
        password: "",
        passwordEnabled: false,

        loading: true,
    };
  }

    handleCreateJam = () => {

        if (this.state.type === '' || this.state.name === ''){
            alert('Please Fill All Information!');
            return;
        }

        let creator = getUserId()
        let {name,password,jambuilderData} = this.state
        let setup = {
            createdBy: creator,
            name,
            password: password === "" ? null : password,
            team: null, /*this.state.jamSelectedTeam ? this.state.jamSelectedTeam._id : null, */
        }

        this.props.client.mutate({
            mutation: DUPLICATE_GAME,
            variables: {
                _id: jambuilderData.general.gameLink,
                setup,
                automationChange: null,
            }
        }).then((status)=>{
            // console.log(status)
            this.setState({
                name:"",
                password:"",
                passwordEnabled: false, 
                showPopup:false, 
                jambuilderData: null, 
                isDataReady:false,
            });
            // this.jbIndex = null
            window.open(`/game/${status.data.gameDuplicate._id}`)
            //window.location.reload(); // temporary for jambuilder setup
        })
    }



    handleClose = () => {
        this.setState({
            jambuilderData: null,
            isDataReady: false,
            showPopup: false,
        })
    }

    handleChange = (event) => {
        let item = event.target.name
        this.setState({
            [item]: event.target.value
        })
    }

    fetchGame = async (jid) => {
        try {
            const { data } = await this.props.client.query({
                query: GET_JAMBUILDER_BY_ID(jid),
                fetchPolicy: 'network-only'
            });
            // console.log(data)
            
            this.setState({ 
                jambuilderData: data.jamBuilderById,
                isDataReady: true 
            });
        } catch (error) {
            console.error('Error fetching data:', error);
            this.setState({ isDataReady: false, showPopup: false });
        }
    }

    openPopup = (_id) => {
        // let temp = 'client.jamit.io/jambuilder/123456'
        //console.log(url)
        //let _id = this.sanitizeId(url)
        // console.log(_id)
        if(_id){
            this.setState({ showPopup: true }, () => {
                if (!this.state.isDataReady) {
                    this.fetchGame(_id);
                }
            });
        }else{
            window.alert('Bad Jambuilder ID!')
        }

    }

    sanitizeId = (url) => {
        const match = url.match(/([a-f0-9]{24})$/i);
        return match ? match[1] : null
    }

    // Modified popup function
    popUp = (classes) => {
        // Don't render anything if showPopup is false
        if (!this.state.showPopup) return null;
        
        // Show loading while fetching data
        if (!this.state.isDataReady) {
            return (
                <Card className={classes.popUp}>
                    <div className={classes.popUpContent} style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                        <p>Loading...</p>
                    </div>
                </Card>
            );
        }
        // Data is ready, show the popup content
        return (
            <Card className={classes.popUp}>
                <div className={classes.popUpHeader}>
                    Host a new Jam
                </div>
                <Divider/>
                <div className={classes.popUpContent}>
                    <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                        <b>Jam Name *</b>
                        <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                        <InputBase
                            className={classes.field}
                            placeholder="Example: Wayne's World"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleChange}
                            inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                        />
                        
                        <div style={{color:"#4F4F4F"}}>
                            <div style={{fontSize:"0.875rem", display:"flex", alignItems:"center"}}>
                                <b>Jam Password</b>
                                
                                <div style={{marginLeft:"10px", display:"flex", alignItems:"center"}}>
                                    <Switch
                                        color="primary"
                                        checked={this.state.passwordEnabled}
                                        onChange={(e) => this.setState({ passwordEnabled: e.target.checked, password: "" })}
                                    />
                                </div>

                                <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                            </div>

                            <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>
                                Only those with your jam's password may view your waiting room. 
                                If none is set, anyone can view your waiting room!
                            </p>
                        </div>

                        <InputBase
                            className={classes.field}
                            type="password"
                            placeholder="password"
                            name="password"
                            value={this.state.password}
                            disabled={!this.state.passwordEnabled}
                            onChange={this.handleChange}
                            inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                        />
                        
                        {/* <FormControl style={{width:"100%", marginTop:"15px"}}>
                            <b style={{fontSize:"0.875rem", color:"#4F4F4F"}}>Select Team</b>

                            <Select
                                value={this.state.jamSelectedTeamName}
                                onChange={(e) => {
                                    if(e.target.value){
                                        this.setState({ 
                                            jamSelectedTeam: e.target.value, 
                                            jamSelectedTeamName: e.target.value.name 
                                        })
                                    }else{
                                        this.setState({
                                            jamSelectedTeam: null, 
                                            jamSelectedTeamName: null 
                                        })
                                    }
                                }} 
                                input={<InputBase className={classes.field} />}
                                displayEmpty
                                renderValue={(value) => {
                                    if (value === null) {
                                        return <span style={{color:"#BDBDBD"}}>Without team</span>;
                                    }
                                    return this.state.jamSelectedTeamName
                                }}
                            >
                                <MenuItem value={null}>
                                    <em>Without team</em>
                                </MenuItem>
                                {this.state.teams.map(t => (
                                    <MenuItem key={t._id} value={t}>
                                        {t.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}

                        <Button
                            onClick={this.handleCreateJam}
                            disabled={(this.state.name === '' ? true : false) || this.state.loading}
                            className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                        >
                            Go to waiting room
                        </Button>
                    </FormControl>
                </div>
            </Card>
        )
    }

    componentDidMount() {
        // Extract eventId from URL path
        const pathSegments = window.location.pathname.split('/');
        const eventId = pathSegments[pathSegments.length - 1];
        // console.log(eventId)
           
        if (eventId) {
            this.setState({ eventId }, () => {
            this.fetchEventData(eventId);
            });
        }
    }

    // Add fetchEventData method
    fetchEventData = async (eventId) => {
        // console.log(eventId)
        try {
            const { data } = await this.props.client.query({
            query: GET_EVENT_BY_ID(eventId),
            fetchPolicy: 'network-only'
            });

            const event = data.eventById;
            // console.log(event)

            this.setState({
            eventName: event.name,
            bannerImage: event.bannerImage,
            eventDescription: event.description,
            sessions: event.activity.map((act, index) => ({
                id: act.link,
                name: act.name,
                description: act.description,
                link: act.link,
            })),
            loading: false,
            });
        } catch (error) {
            console.error('Error fetching event:', error);
            this.setState({ loading: false });
        }
    }

    // Helper method to determine link type
    getLinkType = (link) => {
        if (!link) return null;
        
        if (link.includes('/jambuilder/') || link.match(/^[a-f0-9]{24}$/i)) {
            return 'jambuilder';
        } else if (link.includes('/game/')) {
            return 'game';
        } else if (link.includes('/event/page/')) {
            return 'event';
        }
        
        return null;
    }

    // Helper method to extract ID from link
    extractIdFromLink = (link) => {
        const match = link.match(/([a-f0-9]{24})/i);
        return match ? match[1] : link;
    }

    handleSessionStart = (link) => {
        const linkType = this.getLinkType(link);
        const linkId = this.extractIdFromLink(link);

        switch(linkType) {
            case 'jambuilder':
            // Open popup to create jam from jambuilder
            // this.setState({ selectedSessionLink: linkId }, () => {
            //     this.openPopup(linkId);
            // });
            this.openPopup(linkId)
            break;
            
            case 'game':
            // Open game directly in new tab
            window.location.href = `/game/${linkId}`;
            break;
            
            case 'event':
            // Navigate to event page
            window.location.href = `/event/page/${linkId}`;
            break;
            
            default:
            alert('Invalid link type');
        }
    }

    render(){
        const { classes } = this.props;
        const { sessions, eventName, bannerImage, eventDescription, loading } = this.state;

        if (loading) {
            return (
            <>
                <GameTopPanel/>
                <Box className={classes.root}>
                <Container maxWidth="md" style={{ padding: '100px 20px', textAlign: 'center' }}>
                    <CircularProgress />
                    <Typography style={{ marginTop: '20px' }}>Loading event...</Typography>
                </Container>
                </Box>
                <FooterPanel/>
            </>
            );
        }
        return (
            <>
            <GameTopPanel/>
            <Box className={classes.root}>
                {/* Update banner to use state */}
                <Box className={classes.headerBannerOnly}>
                {bannerImage ? (
                    <img 
                    src={`${config.backend.uri}/static/uploads/${bannerImage}`} 
                    alt="Banner" 
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                ) : (
                    <img 
                    src={dndBanner} 
                    alt="Banner" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                )}
                </Box>

                <Container maxWidth="md" className={classes.contentContainer}>
                <Box className={classes.pageHeader}>
                    <Box className={classes.titleSection}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                        <WorkshopIcon className={classes.workshopIcon} style={{ fontSize: '16px' }} />
                        <span style={{ fontSize: '12px', fontWeight: 500, color: '#666' }}>Workshop</span>
                        </div>
                        {/* Update to use state */}
                        <Typography className={classes.pageTitle}>
                        {eventName}
                        </Typography>
                    </div>
                    </Box>
                    <Button 
                    className={classes.shareButton}
                    startIcon={<ShareIcon />}
                    >
                    SHARE
                    </Button>
                </Box>

                <Box className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                    Overview
                    </Typography>
                    {/* Update to use state */}
                    <Typography className={classes.overviewText}>
                    {eventDescription}
                    </Typography>
                </Box>

                <Box className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                    Sessions
                    </Typography>

                    {sessions.map((session,index) => (
                    <Paper key={index} className={classes.sessionCard} elevation={0}>
                        <Box className={classes.sessionInfo}>
                        <Typography className={classes.sessionName}>
                            {session.name}
                        </Typography>
                        <Typography className={classes.sessionDescription}>
                            {session.description}
                        </Typography>
                        </Box>
                        <Button 
                        disabled={session.link ? false : true}
                        variant="contained" 
                        className={classes.hostButton}
                        onClick={() => {
                            //console.log(session.id)
                            //this.openPopup(session.id)
                            this.handleSessionStart(session.id)
                           //this.handleSessionStart("client.samit.io/jambuilder/68b158d678c9c733ef08d480")
                            //this.handleSessionStart("client.samit.io/game/60f0f874cca2023440cdf4d3")
                            //this.handleSessionStart("client.samit.io/event/page/6971458644b55e697e01dd29")
                        }}
                        >
                        {session.link ? "START" : "SCHEDULED"}
                        </Button>
                    </Paper>
                    ))}
                </Box>
                </Container>
            </Box>
            <Modal disableAutoFocus={true} className={classes.modal} open={this.state.showPopup} onClose={this.handleClose}>
                {this.popUp(classes)}
            </Modal>
            <FooterPanel/>
            </>
        );
    }
}

export default withApollo(withStyles(styles)(InkspireEventPage));